<template>
  <div>
    <div class="mb-4 neutral--text text--tone-300 text-label-m">
      {{ label }}
    </div>
    <v-item-group
      v-bind="$attrs"
      v-on="$listeners"
      class="mb-4"
      @change="$emit('filter', $event)"
    >
      <v-item
        #default="{ active, toggle }"
        v-for="item, key in computedItems"
        :key="key"
        :value="item.id"
      >
        <BaseCheckbox
          :label="item.attributes.name || item.label"
          :input-value="active"
          @change="toggle(!active)"
        />
      </v-item>
    </v-item-group>
    <BaseButton
      color="transparent"
      :ripple="false"
      :height="12"
      v-if="items.length > maxFields"
      @click="showAll = !showAll"
    >
      <div class="brand-secondary--text text--tone-400 text-label-m text-decoration-underline">
        {{ buttonComputedText }}
      </div>
    </BaseButton>
  </div>
</template>

<script>
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  components: {
    BaseCheckbox,
    BaseButton,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    maxFields: {
      type: Number,
      default: 99,
    },
    showAllText: {
      type: String,
      default: 'Voir tout',
    },
    showLessText: {
      type: String,
      default: 'Voir moins',
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  computed: {
    computedItems() {
      if (this.showAll) {
        return this.items;
      }
      return this.items.slice(0, this.maxFields);
    },
    buttonComputedText() {
      return this.showAll ? this.showLessText : this.showAllText;
    },
  },
};
</script>
